import { useLocation } from 'react-router-dom';
import { FloatingActionButton } from '~/components/FloatingActionButton';
import { useAuth } from '~/hooks/useAuth';
import { useBreakpoint } from '~/hooks/useBreakpoint';

type AddButtonProps = {
  label?: string;
  to?: string;
  targetSelector?: string;
  hierarchy?: 'primary' | 'secondary';
  hideWhenCreateOutletOpen?: boolean;
  /** Hide FAB (e.g. mobile job Select mode — bulk bar occupies the thumb zone). */
  hidden?: boolean;
};

export function AddButton({ label, to, hidden }: AddButtonProps) {
  const { can } = useAuth();
  const { pathname } = useLocation();
  const { isMobile } = useBreakpoint();

  const computedLabel = label
    ? label.startsWith('+')
      ? label
      : `${label}`
    : 'New';

  // Determine resource segment for permission check
  const resolveTargetPath = () => {
    if (to) {
      return to.startsWith('/') ? to : `/${pathname.split('/')[1]}/${to}`;
    }
    // default "new" under current resource
    return `/${pathname.split('/')[1]}/new`;
  };

  const targetPath = resolveTargetPath();
  const targetSegment = targetPath.split('/')[1] || '';
  const createResource = `${targetSegment}.create`;

  if (!can(createResource) || hidden) return null;

  const actions = [{ label: computedLabel, to: to ?? 'new' }];

  return (
    <>
      {isMobile ? (
        /* Mobile: keep gradient overlay and centered FAB */
        <div className='pointer-events-none fixed bottom-0 left-0 right-0 z-30 flex h-1/4 justify-center md:h-1/5 '>
          <FloatingActionButton actions={actions} />
          <div className='absolute inset-0 bg-gradient-to-t from-white md:via-white'></div>
        </div>
      ) : null}
    </>
  );
}
